import { useCallback, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePinTrigger } from "../hooks/usePinTrigger";
import { clearKioskSession } from "../utils/kioskSession";
import { closeApp } from "../utils/closeApp";
import OTPModal from "./OTPModal";

const PIN_EXCLUDE_SELECTORS = [
  "button",
  "input",
  "select",
  "textarea",
  "a",
  ".modal",
  ".cartModal",
  ".shopModal",
  ".shopNotice",
  ".pwa-install-banner",
  ".pwaInstallBanner",
  ".quitLeave",
  ".idleModal",
];

const isHomePath = (pathname) =>
  (pathname || "/").replace(/\/+$/, "") === "" || pathname === "/";

function GlobalPinHandler() {
  const [showPinModal, setShowPinModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  usePinTrigger({
    onTrigger: () => setShowPinModal(true),
    excludeSelectors: PIN_EXCLUDE_SELECTORS,
    clickDelay: 500,
    holdDuration: 5000,
  });

  const handlePinSuccess = useCallback(() => {
    setShowPinModal(false);

    if (isHomePath(pathRef.current)) {
      clearKioskSession();
      toast.success("PIN verified. Closing the app.");
      window.setTimeout(() => closeApp(), 50);
      return;
    }

    clearKioskSession();
    toast.success("PIN verified. Returning to the home screen.");
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <OTPModal
      show={showPinModal}
      onHide={() => setShowPinModal(false)}
      onSuccess={handlePinSuccess}
    />
  );
}

export default GlobalPinHandler;
